module.exports = __webpack_public_path__ + "img/available.27d3cd56.svg";